import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import { FILTER_CONSTS } from '../../../constants/TopFilterConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export const CategoryLabel = styled.div.withConfig({
  displayName: "LearningContentThumbnail__CategoryLabel",
  componentId: "q1quly-0"
})(["color:", ";text-transform:capitalize;", ";"], theme.colors.OLAF, ({
  $isGhost
}) => $isGhost ? `opacity: .5` : '');
export const LearningContentCompletedMessage = ({
  type
}) => {
  switch (type) {
    case 'SHORT_FORM_CONTENT':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.shortContent.watched"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.completedIcontext"
      });
  }
};
export const LearningContentTitle = ({
  type,
  lessonTypes,
  certification
}) => {
  switch (type) {
    case 'SHORT_FORM_CONTENT':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'learningCenter.shortCard.label'
      });
    case 'LESSON':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.resources.type.${lessonTypes !== null && lessonTypes !== void 0 && lessonTypes.length ? lessonTypes[0] : FILTER_CONSTS.LESSON_TYPES.LESSON}`
      });
    case 'TRACK':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: certification ? `learningCenter.awards.BADGE_AND_CERTIFICATE` : 'learningCenter.resources.type.TRACK'
      });
    case 'PLAYLIST':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.playlist"
      });
    case 'LEARNING_PATH':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.hubspotPlaylist"
      });
    default:
      return undefined;
  }
};